/** Preview + caption an image (or gallery) before sending it into the chat. */
export function ImagePreviewModal({
  pendingImage,
  caption,
  setCaption,
  onSend,
  onCancel,
}: {
  pendingImage: { files: File[]; urls: string[] };
  caption: string;
  setCaption: (v: string) => void;
  onSend: () => void;
  onCancel: () => void;
}) {
  return (
    <div className="modal-backdrop" onClick={onCancel}>
      <div className="modal img-preview" onClick={(e) => e.stopPropagation()}>
        <div className={`preview-grid${pendingImage.urls.length > 1 ? " multi" : ""}`}>
          {pendingImage.urls.map((u, i) => (
            <img key={i} src={u} alt="preview" />
          ))}
        </div>
        <input
          value={caption}
          onChange={(e) => setCaption(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && onSend()}
          placeholder="Add a caption…"
          autoFocus
        />
        <div className="img-preview-actions">
          <button className="linkish" onClick={onCancel}>
            Cancel
          </button>
          <button onClick={onSend}>
            Send{pendingImage.files.length > 1 ? ` (${pendingImage.files.length})` : ""}
          </button>
        </div>
      </div>
    </div>
  );
}
